import { useQueryClient } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useOptimisticMutation, type Variables } from '../../../../hooks/use-optimistic-mutation';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { TeamApiResponse, TeamMemberApiResponse } from '../../types';
import { QK_ACCOUNT_TEAM } from './use-account-team';

export function useRemoveTeamMember() {
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();
  const queryClient = useQueryClient();

  async function removeMember(userId: number) {
    await accountApi.team(teamId).removeMember(userId);
  }

  return useOptimisticMutation<TeamApiResponse, Variables<typeof removeMember>>({
    queryClient,
    queryKey: QK_ACCOUNT_TEAM(teamId),
    mutationFn: removeMember,
    optimisticUpdate: (prev, id) => {
      if (!prev) {
        return prev;
      }

      return { ...prev, users: prev.users.filter((user: TeamMemberApiResponse) => user.id !== id) };
    },
  });
}
